
export const base_url = () => {
    return import.meta.env.VITE_API_BASE_URL
}
